var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"login_bg"},[_c('v-col',[_c('div'),_c('div',{staticClass:"d-flex align-center justify-center"},[_c('router-view')],1),_c('div',{staticClass:"copyright"},[_vm._v("CKH © 2021")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }